
export const timeFormat = (time, format = "YYYY-MM-DD", currentFormat) => {
	let date = "";
	if (currentFormat) {
		date = moment(new Date(time), currentFormat).format(format) || time;
	} else {
		date = moment(new Date(time)).format(format) || time;
	}

	if (date === "Invalid date") {
		date = "--";
	}
	return date;
};

export const timeFromNow = (time, format = "YYYY-MM-DD HH:mm:ss") => {
	let timeStr = moment(new Date(time)).format(format);
	if (moment(new Date(time)).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
		const fromNowStr = moment(new Date(time)).fromNow(true);
		if (fromNowStr.indexOf("小时") > 0) {
			timeStr = `${parseInt(fromNowStr)}小时前`;
		} else if (fromNowStr.indexOf("小时") === -1 && fromNowStr.indexOf("分钟") === -1) {
			timeStr = "几秒前";
		} else {
			timeStr = `${fromNowStr}前`;
		}
	}
	return timeStr;
};


export const dateTimeIsAfter = (time, compareTo, offset = 0, offsetType = "hour") => {
	return moment(new Date(time)).add(offset, offsetType).isAfter(compareTo);
};
